import { applyMiddleware, createStore } from "redux";
import rootReducer from "./reducers";
import { analyticsPopupMiddleware } from "./analyticsMiddleware";

const store = createStore(rootReducer, applyMiddleware(analyticsPopupMiddleware));

export default store;
export { store };
